import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React, { forwardRef } from 'react';
import { useComponentDefaultProps, useMantineTheme, rem } from '@mantine/styles';
import { ColorSlider } from '../ColorSlider/ColorSlider.js';
import { round } from '../converters/parsers.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var defaultProps = {};
var AlphaSlider = forwardRef(function (props, ref) {
  var _a = useComponentDefaultProps("AlphaSlider", defaultProps, props),
      value = _a.value,
      _onChange = _a.onChange,
      _onChangeEnd = _a.onChangeEnd,
      color = _a.color,
      __staticSelector = _a.__staticSelector,
      others = __objRest(_a, ["value", "onChange", "onChangeEnd", "color", "__staticSelector"]);

  var theme = useMantineTheme();

  var _color = theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3];

  return /* @__PURE__ */React.createElement(ColorSlider, __spreadProps(__spreadValues({}, others), {
    ref,
    value,
    onChange: function onChange(val) {
      return _onChange(round(val, 2));
    },
    onChangeEnd: function onChangeEnd(val) {
      return _onChangeEnd(round(val, 2));
    },
    maxValue: 1,
    round: false,
    __staticSelector: __staticSelector || "AlphaSlider",
    overlays: [{
      backgroundImage: "linear-gradient(45deg, ".concat(_color, " 25%, transparent 25%), linear-gradient(-45deg, ").concat(_color, " 25%, transparent 25%), linear-gradient(45deg, transparent 75%, ").concat(_color, " 75%), linear-gradient(-45deg, ").concat(theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white, " 75%, ").concat(_color, " 75%)"),
      backgroundSize: "".concat(rem(8), " ").concat(rem(8)),
      backgroundPosition: "0 0, 0 ".concat(rem(4), ", ").concat(rem(4), " -").concat(rem(4), ", -").concat(rem(4), " 0")
    }, {
      backgroundImage: "linear-gradient(90deg, transparent, ".concat(color, ")")
    }, {
      boxShadow: "rgba(0, 0, 0, .1) 0 0 0 ".concat(rem(1), " inset, rgb(0, 0, 0, .15) 0 0 ").concat(rem(4), " inset")
    }]
  }));
});
AlphaSlider.displayName = "@mantine/core/AlphaSlider";
export { AlphaSlider };